<div class="base-btn-submenu-cadastro">
    <div class="btn-submenu-cadastro submenu-mr">
        <a (click)="mainService.loginService.changeRoute('/cartao')">
            <img src="../../../../assets/img/icons/bt_cadastro_branco.png" alt="Icone btn cadastro">
            <span>Cadastro</span>
        </a>
    </div>
    <div class="btn-submenu-cadastro">
        <a (click)="mainService.loginService.changeRoute('/cartao/epwd')">
            <img src="../../../../assets/img/icons/bt_senha_eletrônica.png" alt="Icone btn Senha eletronica">
            <span>Senha <br> Eletrônica</span>
        </a>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/menu-superior/meu-cadastro/submenu/submenu.component.html